module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/6xC9nQvLTUqagkMcOwSIic-29323714ff13e4c21d5dbd5f41976be7.jpg";